import SingleSelectPage from "@components/SingleSelectPage"

const OPTIONS = [
  "lostAndWantMore",
  "triedButUnsuccessful",
  "lostButGainedBack",
  "neverTried",
] as const

export default function WeightLossAttempts() {
  return (
    <SingleSelectPage translationKey="weightLossAttempts" options={OPTIONS} />
  )
}
